import { useCallback, useEffect, useState } from 'react';
import { WindTurbineService } from '../../services/windTurbine/windTurbineService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage wind turbine fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de aerogeneradores.
----------------------------------------------------------------------------------------*/

const useWindTurbine = (initialFilters = {}) => {

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999, 
        filter_filters: { ...initialFilters } 
    });

    const fetchWindTurbines = async () => {
        try {
            const service = new WindTurbineService();
            const response = await service.listForSelect(filters);
            const fetchedData = response.getResponseData().data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; }) => ({
                    value: data.id,
                    label: data.name,
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching windTurbines:', error);
        }
    };

    useEffect(() => {
        fetchWindTurbines();
    }, [filters]);

    const getWindTurbinesList = () => {
        return data;
    };

    const updateWindTurbineHookFilters = (newFilters: any) => {
        setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
    };

    return { fetchWindTurbines, getWindTurbinesList, updateWindTurbineHookFilters };
}

export default useWindTurbine;